import Vue from 'vue';
import Router from 'vue-router';

// RouterTabRoutes
import { RouterTabRoutes } from 'vue-router-tab';

// layout component
import Frame from './components/frame.vue';

//**********AUTH************ */
const Login = () =>
  import(/* webpackChunkName: "login" */ './views/user/login');
const Register = () =>
  import(/* webpackChunkName: "login" */ './views/user/register');

//**********MAIN************ */
const Home = () => import(/* webpackChunkName: "home" */ './views/home');
const CRM = () => import(/* webpackChunkName: "crm" */ './views/crm');
const Perm = () => import(/* webpackChunkName: "perm" */ './views/perm');
const Temp = () => import(/* webpackChunkName: "temp" */ './views/temp');
const Settings = () =>
  import(/* webpackChunkName: "settings" */ './views/settings');
const Admin = () => import(/* webpackChunkName: "admin" */ './views/admin');
const Company = () =>
  import(/* webpackChunkName: "company" */ './views/admin/company');
const Help = () => import(/* webpackChunkName: "help" */ './views/help');

//********TEMP************ */
const Candidates = () =>
  import(/* webpackChunkName: "candidates" */ './views/temp/candidates');
const Clients = () =>
  import(/* webpackChunkName: "clients" */ './views/temp/clients');
const Invoices = () =>
  import(/* webpackChunkName: "invoices" */ './views/temp/invoices');
const Planner = () =>
  import(/* webpackChunkName: "planner" */ './views/temp/planner2');
const Timesheets = () =>
  import(/* webpackChunkName: "timesheets" */ './views/temp/timesheets');

Vue.use(Router);

export const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    // {
    //   path: '/',
    //   // parent component must contain <router-tab>
    //   component: Frame,
    //   // routes that serve as tab contents
    //   children: [
    //     // integrate RouterTabRoutes to support iframe tabs
    //     ...RouterTabRoutes,

    {
      path: '/',
      component: Home,
      name: 'Home',
      meta: {
        title: 'Home',
        breadcrumbs: [{ name: 'Home', link: '/' }],
      },
    },

    {
      path: '/settings',
      name: 'Settings',
      component: Settings,
      meta: {
        title: 'Settings',
        breadcrumbs: [
          { name: 'Home', link: '/' },
          { name: 'Settings', link: '/settings' },
        ],
      },
    },
    {
      path: '/admin',
      name: 'Admin',
      component: Admin,
      meta: {
        title: 'Admin',
        breadcrumbs: [
          { name: 'Home', link: '/' },
          { name: 'Admin', link: '/admin' },
        ],
      },
    },
    {
      path: '/admin/:id',
      name: 'Company',
      component: Company,
      props: true,
      meta: {
        title: 'Company',
        breadcrumbs: [
          { name: 'Home', link: '/' },
          { name: 'Admin', link: '/admin' },
          { name: 'Company', link: '/admin/:id' },
        ],
      },
    },
    {
      path: '/help',
      name: 'Help',
      component: Help,
      meta: {
        title: 'Help',
        breadcrumbs: [
          { name: 'Home', link: '/' },
          { name: 'Help', link: '/help' },
        ],
      },
    },
    {
      path: '/crm',
      name: 'CRM',
      component: CRM,
      meta: {
        title: 'CRM',
        breadcrumbs: [
          { name: 'Home', link: '/' },
          { name: 'CRM', link: '/crm' },
        ],
      },
    },
    {
      path: '/perm',
      component: Perm,
      name: 'Perm',
      meta: {
        title: 'PERM',
        breadcrumbs: [
          { name: 'Home', link: '/' },
          { name: 'Perm', link: '/perm' },
        ],
      },
    },
    {
      path: '/temp',
      component: Temp,
      name: 'Temp',
      meta: {
        title: 'Temp',
        breadcrumbs: [
          { name: 'Home', link: '/' },
          { name: 'Temp', link: '/temp' },
        ],
      },
    },
    {
      path: '/temp/invoices/:id?',
      component: Invoices,
      name: 'Invoices',
      props: true,
      meta: {
        title: 'Invoices',
        breadcrumbs: [
          { name: 'Home', link: '/' },
          { name: 'Temp', link: '/temp' },
          { name: 'Invoices', link: '/temp/invoices' },
        ],
      },
    },
    {
      path: '/temp/candidates/:id?',
      component: Candidates,
      name: 'Candidates',
      props: true,
      meta: {
        title: 'Candidates',
        breadcrumbs: [
          { name: 'Home', link: '/' },
          { name: 'Temp', link: '/temp' },
          { name: 'Candidates', link: '/temp/candidates' },
        ],
      },
    },
    {
      path: '/temp/clients/:id?',
      component: Clients,
      name: 'Clients',
      props: true,
      meta: {
        title: 'Clients',
        breadcrumbs: [
          { name: 'Home', link: '/' },
          { name: 'Temp', link: '/temp' },
          { name: 'Clients', link: '/temp/clients' },
        ],
      },
    },
    {
      path: '/temp/planner',
      component: Planner,
      name: 'Planner',
      meta: {
        title: 'Planner',
        breadcrumbs: [
          { name: 'Home', link: '/' },
          { name: 'Temp', link: '/temp' },
          { name: 'Planner', link: '/temp/planner' },
        ],
      },
    },

    {
      path: '/temp/timesheets/:id?',
      component: Timesheets,
      name: 'Timesheets',
      props: true,
      meta: {
        title: 'Timesheets',
        breadcrumbs: [
          { name: 'Home', link: '/' },
          { name: 'Temp', link: '/temp' },
          { name: 'Timesheets', link: '/temp/timesheets' },
        ],
      },
    },

    {
      path: '/login',
      component: Login,
      name: 'Login',
      meta: {
        public: true,
        breadcrumbs: [{ name: 'Login', link: '/login' }],
      },
    },
    {
      path: '/register',
      component: Register,
      name: 'Register',
      meta: {
        public: true,
        breadcrumbs: [{ name: 'Register', link: '/register' }],
      },
    },

    { path: '*', redirect: '/' },
  ],
});
// });

router.beforeEach((to, from, next) => {
  var authRequired = true;
  if (to.meta.public) {
    authRequired = !to.meta.public;
  }
  const user = JSON.parse(localStorage.getItem('user'));
  const company = localStorage.getItem('company');

  var hasInfo = company && user;

  //Check if public
  if (!authRequired) {
    return next();
  }

  if (user) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + user.token;
  }

  //Check if logged in
  if (authRequired && !hasInfo) {
    return next('/login');
  }

  //Already logged in
  if (!authRequired && hasInfo) {
    return next('/');
  }

  next();
});
